import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faCommentDots } from "@fortawesome/free-solid-svg-icons";

import "./GlobalCareerCTA.css";
import Common_Button from "../../Common_Components/common_button/Common_Button";
import { useNavigate } from "react-router-dom";

const GlobalCareerCTA = () => {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/new/apply_now");
  };

  const handleContactUs = () => {
    navigate("/new/contact_us");
  };

  return (
    <section className="global_career_cta">
      <div className="container">
        <div className="cta_content">
          <div className="cta_text">
            <h2 className="cta_title">Ready to Start Your Global Career?</h2>

            <p className="cta_description">
              Join thousands of professionals who have successfully placed
              globally. Apply now for free consultation.
            </p>
          </div>

          <div className="cta_actions">
            <Common_Button
              type="button"
              text="Apply Now"
              icon={faUserPlus}
              className="application_submit_btn"
              onClick={handleApplyNow}
            />

            <Common_Button
              type="button"
              text="Talk to Us"
              icon={faCommentDots}
              className="cta_button"
              onClick={handleContactUs}
            />

            {/* <button
              className="cta_button"
              onClick={() => navigate("/new_folder/contact_us")}
            >
              <FontAwesomeIcon icon={faCommentDots} />
              <span className="cta_button_text">Talk to Us</span>
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalCareerCTA;
